module.exports = __webpack_public_path__ + "media/images/expert__tiril-eckhoff-9b186953996df04e07c2b1a8a85d42cb.png";